export default __webpack_public_path__ + "static/media/instagram.78b50909.webp";